import { Link } from "react-router-dom";
import "./section-head-style.scss";

//區塊標題
//  eyebrow 是標題上方那行小字（例「新品熱門」），
//  拆成獨立元件是因為首頁每個區塊都長一樣，複製六份之後改樣式要改六個地方。
const SectionHead = ({ eyebrow, title, moreLabel = "看更多", morePath }) => (
  <div className="sh">
    <div className="sh__text">
      {eyebrow && <span className="sh__eyebrow">{eyebrow}</span>}
      <h2 className="sh__title">{title}</h2>
    </div>

    {morePath && (
      <Link to={morePath} className="sh__more">
        {moreLabel}
        <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
          <path d="M9 5l7 7-7 7" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </Link>
    )}
  </div>
);

export default SectionHead;
